var _G;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgFunctionalCardioOutlined(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    transform: "matrix(1.1 0 0 1.1 -2.2 -2.2)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M21.852 8.6a2.36 2.36 0 002.646-2.652 2.367 2.367 0 00-2.033-2.052 2.36 2.36 0 00-2.646 2.652c.14 1.075.989 1.926 2.033 2.052z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M25.376 14.546c.265.223.613.32.962.265a1.22 1.22 0 00.85-.517l3.064-4.327a1.25 1.25 0 00-.293-1.745 1.244 1.244 0 00-1.74.294l-2.3 3.238c-.668-.796-2.2-2.36-4.61-2.96a8.065 8.065 0 00-2.033-.25c-1.685.11-3.357.237-5.042.348a1.27 1.27 0 00-1.17 1.158l-.349 4.816a1.243 1.243 0 001.157 1.34 1.242 1.242 0 001.337-1.158l.264-3.727 2.535-.181-.32 5.164c-.084.684.111 1.703.919 2.373.14.111.278.21.404.28l-.446 5.75-2.187 5.458a1.25 1.25 0 00.696 1.633c.154.056.307.083.46.083a1.26 1.26 0 001.17-.795l2.257-5.64c.042-.112.07-.237.083-.362l.46-5.71h3.593l-1.24 4.747a1.256 1.256 0 001.212 1.577c.557 0 1.059-.377 1.212-.935l1.643-6.296a1.27 1.27 0 00-.223-1.088 1.245 1.245 0 00-.988-.49h-4.43l.585-4.382 2.508 2.038h0z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#functional-cardio-outlined_svg__a)",
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M6.063 5.613c1.126-1.773 3.048-2.94 5.228-2.94 2.057 0 3.883 1.039 5.029 2.644M11.291 15.866c-3.469 0-6.28-2.953-6.28-6.596",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.49 10.298l1.552-1.63 1.507 1.583M16.32 3.014V5.32h-2.132",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "functional-cardio-outlined_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(2.85 2)",
    d: "M0 0h14.111v14.539H0z"
  }))))));
}

export default SvgFunctionalCardioOutlined;